module.exports = __webpack_public_path__ + "img/6-s.407b0eed.png";